import { render, staticRenderFns } from "./GradientExternalLinkIcon.vue?vue&type=template&id=75444247"
import script from "./GradientExternalLinkIcon.vue?vue&type=script&lang=ts"
export * from "./GradientExternalLinkIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports